import { companyService } from '@/helpers/services/company.service';
import i18n from '@/i18n';
// import router from '@/router/index';
import { sharedHelper, filtersHelper } from '@/utils';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const COMPANY_MODULE = "company";

// actions
export const GET_ALL_COMPANY = 'getAllCompany';
export const CREATE_COMPANY = 'createCompany';
export const GET_COMPANY = 'getCompany';
export const UPDATE_COMPANY = 'updateCompany';
export const UPDATE_COMPANY_STATUS = 'updateCompanyStatus';

// mutations
const REQUESTING = "requesting";
const ALL_COMPANY_SUCCESS = "allCompanySuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_COMPANY_SUCCESS = "getCompanySuccess";

export const actions = {
    [GET_ALL_COMPANY]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        companyService
            .getAllCompany(filter)
            .then((result) => {
                commit(ALL_COMPANY_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                let message = sharedHelper.getErrorMessage(error);
                sharedHelper.alertErrorMessage(message, error?.response?.data?.code);
                commit(FAILURE);
            });
    },
    [CREATE_COMPANY]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return companyService
            .createCompany(data)
            .then((result) => {
                var message = i18n.t('label.createX', [i18n.t('module.company')]);
                sharedHelper.alertSuccessMessage(message);
                commit(SUCCESS);
                dispatch(GET_ALL_COMPANY, {filter});
                return result;
            })
            .catch((error) => {
                let message = sharedHelper.getErrorMessage(error);
                sharedHelper.alertErrorMessage(message, error?.response?.data?.code);
                commit(FAILURE);
            });
    },
    [GET_COMPANY]({commit}, {id}) {
        commit(REQUESTING, 'detail');
        return companyService
            .getCompany(id)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_COMPANY_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                let message = sharedHelper.getErrorMessage(error);
                sharedHelper.alertErrorMessage(message, error?.response?.data?.code);
                commit(FAILURE);
            });
    },
    [UPDATE_COMPANY]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return companyService
            .updateCompany(data)
            .then((result) => {
                var message = i18n.t('label.updateX', [i18n.t('module.company')]);
                sharedHelper.alertSuccessMessage(message);
                commit(SUCCESS);
                dispatch(GET_ALL_COMPANY, {filter});
                return result;
            })
            .catch((error) => {
                let message = sharedHelper.getErrorMessage(error);
                sharedHelper.alertErrorMessage(message, error?.response?.data?.code);
                commit(FAILURE);
            });
    },
    [UPDATE_COMPANY_STATUS]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return companyService
            .updateCompanyStatus(data)
            .then((result) => {
                var message = i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [i18n.t('module.company')]);
                sharedHelper.alertSuccessMessage(message);
                commit(SUCCESS);
                dispatch(GET_ALL_COMPANY, {filter});
                return result;
            })
            .catch((error) => {
                let message = sharedHelper.getErrorMessage(error);
                sharedHelper.alertErrorMessage(message, error?.response?.data?.code);
                commit(FAILURE);
            });
    }
};

export const mutations = {
    [ALL_COMPANY_SUCCESS](state, {data}) {
        let company = data.data || [];
        state.list.data = company;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);
        if(data.success) {
            state.list.data = company.map(item => {
                return {
                    id: item.uuid,
                    name: item.name,
                    displayName: item.display_name,
                    logoUrl: item.logo_url,
                    budget: filtersHelper.getSmartNumberFormat(item.budget),
                    costing: filtersHelper.getSmartNumberFormat(item.costing),
                    startTime: item.start_operate_time,
                    endTime: item.close_operate_time,
                    operateDescription: item.operate_description,
                    hashtags: item.hashtags,
                    website: item.website_url,
                    annualReportWebsite: item.website_annual_report_url,
                    isActive: item.is_active,
                    isPrivate: item.is_private,
                    isClosingNow: item.isClosingNow,
                    createdBy : item.created_by,
                    createdAt : filtersHelper.getDateFormat(item.created_at),
                    updatedBy : item.updated_by,
                    updatedAt : filtersHelper.getDateFormat(item.updated_at),
                    group: item.group?.name,
                    groupID: item.group == null ? "" : {
                        value: item.group.uuid,
                        text: item.group.name,
                    },
                }
            });
        }
    },
    [GET_COMPANY_SUCCESS](state, data) {
        let info = data.data;
        state.details = {
            id: info.uuid,
            name: info.name,
            displayName: info.display_name,
            logoUrl: info.logo_url,
            budget: filtersHelper.getSmartNumberFormat(info.budget),
            costing: filtersHelper.getSmartNumberFormat(info.costing),
            startTime: info.start_operate_time,
            endTime: info.close_operate_time,
            operateDescription: info.operate_description,
            hashtags: info.hashtags,
            website: info.website_url,
            annualReportWebsite: info.website_annual_report_url,
            isActive: info.is_active,
            isPrivate: info.is_private,
            isClosingNow: info.isClosingNow,
            createdBy : info.created_by,
            createdAt : filtersHelper.getDateFormat(info.created_at),
            updatedBy : info.updated_by,
            updatedAt : filtersHelper.getDateFormat(info.updated_at),
            groupID: info.group == null ? "" : {
                value: info.group.uuid,
                text: info.group.name,
            },
        };
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};